import { SearchIcon } from 'assets/icons';
import { SearchFormContainer } from 'components/Blog/SearchForm';
import { useEventContext } from 'context/EventContext';
import { useRouter } from 'next/router';
import React, { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import styled from 'styled-components';

const EventSearchForm = () => {
  const { dispatch } = useEventContext();
  const { locale } = useRouter();
  const [searchDraft, setSearchDraft] = useState('');

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    dispatch({
      type: 'change',
      newState: { search: searchDraft, currPageNum: 0 },
    });
  };
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    const value = target.value;

    setSearchDraft(value);
  };

  useEffect(() => {
    if (searchDraft === '')
      dispatch({ type: 'change', newState: { search: '', currPageNum: 0 } });
  }, [searchDraft, dispatch]);

  return (
    <EventSearchFormContainer onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder={locale === 'en' ? 'Search' : '검색어를 입력해주세요.'}
        value={searchDraft}
        onChange={handleChange}
        spellCheck={false}
      />
      <button>
        <SearchIcon />
      </button>
    </EventSearchFormContainer>
  );
};

export default EventSearchForm;

const EventSearchFormContainer = styled(SearchFormContainer)``;
